import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { PaginatorInterface } from './paginator.interface';

@Injectable()
export class PaginatorCustomService {

  private disabledSelect = new BehaviorSubject<boolean>(undefined);
  disabledSelect$ = this.disabledSelect.asObservable();

  private quantityByPage = new BehaviorSubject<number>(undefined);
  quantityByPage$ = this.quantityByPage.asObservable();

  private rowSelected = new BehaviorSubject<number>(undefined);
  rowSelected$ = this.rowSelected.asObservable();

  private resultService = new BehaviorSubject<PaginatorInterface>(undefined);
  resultService$ = this.resultService.asObservable();

  private reloadByPage = new BehaviorSubject<number>(undefined);
  reloadByPage$ = this.reloadByPage.asObservable();

  constructor() { }

  selectDisabled(disabled: boolean): void {
    this.disabledSelect.next(disabled);
  }

  getQuantityByPage(page: number): void {
    this.quantityByPage.next(page);
  }

  getRowSelected(row: number): void {
    this.rowSelected.next(row);
  }

  getResulServiceData(data: PaginatorInterface): void {
    this.resultService.next(data);
  }

  sendNumberPage(numberPage: number): void {
    this.reloadByPage.next(numberPage);
  }

}



// WEBPACK FOOTER //
// ./src/app/utils/paginator-custom/paginator-custom.service.ts